import { compressImage } from "utils/helpers/compressImage";
import preset1 from "./preset-1.png";
import preset2 from "./preset-2.png";
import preset3 from "./preset-3.png";
import preset4 from "./preset-4.png";
import preset5 from "./preset-5.png";
import preset6 from "./preset-6.png";
import preset7 from "./preset-7.png";
import preset8 from "./preset-8.png";

export type AudioPreset = { id: string; src: string };
export type UploadAudioPreset = (
  file: File,
  onUploadProgress: (progress: number) => void
) => Promise<{ file: string; url?: string }>;

export const AUDIO_PRESETS: AudioPreset[] = [
  { id: "preset-1", src: preset1 },
  { id: "preset-2", src: preset2 },
  { id: "preset-3", src: preset3 },
  { id: "preset-4", src: preset4 },
  { id: "preset-5", src: preset5 },
  { id: "preset-6", src: preset6 },
  { id: "preset-7", src: preset7 },
  { id: "preset-8", src: preset8 },
];

const ABSOLUTE_URL_PATTERN = /^(https?:|blob:|data:)/;

export const isAudioPresetId = (value?: string): boolean =>
  !!value && AUDIO_PRESETS.some((preset) => preset.id === value);

export const getAudioPreset = (id?: string): AudioPreset | undefined =>
  AUDIO_PRESETS.find((preset) => preset.id === id);

export const resolveAudioThumbnail = (
  thumbnailPath?: string,
  fallbackAssetUrl?: string
): string => {
  if (!thumbnailPath) return AUDIO_PRESETS[0].src;
  const preset = getAudioPreset(thumbnailPath);
  if (preset) return preset.src;
  if (ABSOLUTE_URL_PATTERN.test(thumbnailPath)) return thumbnailPath;
  if (fallbackAssetUrl) return fallbackAssetUrl;
  return thumbnailPath;
};

export const buildAudioThumbnailUrlFromResource = (
  resourceUrl?: string,
  resourcePath?: string,
  thumbnailPath?: string
): string | undefined => {
  if (!resourceUrl || !resourcePath || !thumbnailPath) return undefined;
  return resourceUrl.replace(resourcePath, thumbnailPath);
};

export const uploadAudioPresetThumbnail = async (
  presetId: string,
  uploadFile: UploadAudioPreset,
  onUploadProgress: (progress: number) => void = () => undefined
) => {
  const preset = getAudioPreset(presetId);
  if (!preset) return undefined;

  const response = await fetch(preset.src);
  const blob = await response.blob();
  const rawFile = new File([blob], `${preset.id}.png`, {
    type: blob.type || "image/png",
  });
  const file = await compressImage(rawFile);

  return uploadFile(file, onUploadProgress);
};
